import { List, ListItem, ListItemText, Typography, Box, colors } from '@mui/material';
import { FiberManualRecord as BulletPointIcon } from '@mui/icons-material';

// const data = {
//     "Loss": 89561000000,
//     "Profit": null,
//     "Revenue": 371433000000,
//     "Earnings Per Share": null,
//     "Number of Employees": null
// };

const BulletsSection = ({ data }) => {
    console.log('BulletsSection PROPS Data == ', data)
    // const formatValue = (value) => {
    //     if (value === null || value === undefined || value === '') return '-';
    //     if (typeof value === 'number') {
    //         return value.toLocaleString();
    //     }
    //     return value;
    // };

    const formatValue = (key, value) => {
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'number') {
            // Don't format EPS or Number of Employees in thousands
            if (key === 'Earnings Per Share' || key === 'Number of Employees') {
                return value.toLocaleString();
            }
            // Format other numbers in thousands
            return (value / 1000).toLocaleString() + ' K';
        }
        return value;
    };

    const formatKey = (key) => {
        return key.split(' ').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    return (
        <List>
            {data && Object.entries(data)?.length > 0 && Object.entries(data)?.map(([key, value], index) => (
                <ListItem key={index} sx={{ py: 0 }}>
                    <BulletPointIcon color="primary" sx={{ fontSize: 'small', mr: 1 }} />
                    <ListItemText
                        primary={
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <Typography variant='subtitle1' color={colors.blueGrey[600]} fontWeight="bold">{formatKey(key)}:&ensp;</Typography>
                                <Typography variant='subtitle1'>{formatValue(key, value)}</Typography>
                            </Box>
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default BulletsSection;